import { UserListParams } from './types'

const queryKeyFactory = {
  users: (params: UserListParams) => [
    'users',
    params.company_type,
    params.search,
    params.limit,
    params.next_cursor,
    params.previous_cursor,
    params.order_by_field,
    params.asc_order,
  ],
  allUsers: () => ['users'],
  companiesMetadata: () => ['companiesMetadata'],
  userDetails: (userId: string) => ['userDetails', userId],
  userProfile: () => ['user', 'profile'],
}

export default queryKeyFactory
